module.exports = __webpack_public_path__ + "static/media/042.098bf49c.png";